import { useState } from 'react';
import type { MeResponse } from '@stonelink/shared';
import { api, ApiError } from '../api';
import { Button, ErrorNote, Eyebrow, Input, Label } from '../ui';

export function LoginPage({ onSignedIn }: { onSignedIn: (session: MeResponse) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await api.login(email, password));
    } catch (caught) {
      setError(
        caught instanceof ApiError ? caught.message : 'Could not sign in. Please try again.',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-full items-center justify-center p-6">
      <form onSubmit={(event) => void submit(event)} className="glass w-full max-w-sm p-8">
        <div className="mb-7">
          <Eyebrow>Stonelink Assist</Eyebrow>
          <h1 className="font-display text-4xl leading-none">
            Welcome <em className="text-brand italic">back.</em>
          </h1>
          <p className="mt-3 text-sm text-soft">Sign in to train your assistant.</p>
        </div>

        <div className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          {error && <ErrorNote>{error}</ErrorNote>}
          <Button type="submit" className="w-full" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </div>
      </form>
    </div>
  );
}
